export default "__VITE_ASSET__3651a1e9__"